/* TOADS promotions — countdowns and discount-code copying.
 *
 * Both behaviours belong to the merchant-controls layer: the client sets a
 * cutoff date or a code in the theme editor and this makes them work. They
 * live in one file rather than a section {% javascript %} block because
 * Horizon does not bundle section-level JS.
 *
 * Ticks any [data-toads-countdown] toward its target instant and removes it
 * once it passes. Liquid renders a static fallback first, so this only ever
 * sharpens an already-correct value — if the script never runs, the banner
 * still reads sensibly.
 *
 * The interval adapts: once a second inside the last hour, once a minute
 * before that. A banner counting whole days does not need 3,600 repaints an
 * hour on a mid-range phone.
 */
(function () {
  'use strict';

  function fmt(ms) {
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    if (d > 0) return d + 'd ' + h + 'h';
    if (h > 0) return h + 'h ' + m + 'm';
    if (m > 0) return m + 'm ' + sec + 's';
    return sec + 's';
  }

  function run() {
    var nodes = [].slice.call(document.querySelectorAll('[data-toads-countdown]'));
    if (!nodes.length) return;

    // One scheduler per page. `run` is called again on shopify:section:load,
    // and without this the theme editor stacks a new interval on every save.
    if (window.__toadsCountdownTimer) {
      clearInterval(window.__toadsCountdownTimer);
      window.__toadsCountdownTimer = null;
    }

    var timer = null;
    var every = 0;

    function tick() {
      var soon = false;
      var alive = 0;

      nodes.forEach(function (el) {
        var target = Number(el.dataset.toadsCountdown) * 1000;
        if (!target) { el.remove(); return; }

        var left = target - Date.now();
        if (left <= 0) {
          // A finished countdown says nothing rather than "0s". If it was the
          // only content in its banner, take the banner with it.
          var host = el.closest('[data-toads-countdown-host]');
          (host || el).remove();
          return;
        }

        alive++;
        if (left < 3600000) soon = true;
        var prefix = el.dataset.prefix ? el.dataset.prefix + ' ' : '';
        el.textContent = prefix + fmt(left);
      });

      if (!alive) { clearInterval(timer); timer = null; window.__toadsCountdownTimer = null; return; }

      // setInterval returns a NUMBER in browsers, so the period has to live in
      // its own variable — assigning a property to a primitive throws in strict
      // mode, which is exactly what used to kill this function on every tick.
      var wanted = soon ? 1000 : 60000;
      if (timer !== null && every !== wanted) {
        clearInterval(timer);
        every = wanted;
        timer = setInterval(tick, wanted);
        window.__toadsCountdownTimer = timer;
      }
    }

    tick();
    if (timer === null && document.querySelector('[data-toads-countdown]')) {
      every = 60000;
      timer = setInterval(tick, 60000);
      window.__toadsCountdownTimer = timer;
    }

    // Don't burn cycles in a backgrounded tab; catch up on return. Bound once
    // for the life of the page, not once per run().
    if (!window.__toadsCountdownBound) {
      window.__toadsCountdownBound = true;
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && window.__toadsCountdownTick) window.__toadsCountdownTick();
      });
    }
    window.__toadsCountdownTick = tick;
  }

  /* ---------------------------------------------------------------- copy
   * Click-to-copy for a promo code. Asking a shopper on a phone to carry
   * TOADS15 across two screens loses some of them at checkout.
   * Progressive: with no JS the code is still visible and selectable.
   */

  function flash(button) {
    button.setAttribute('data-copied', 'true');
    setTimeout(function () { button.removeAttribute('data-copied'); }, 2000);
  }

  /* Last resort: if neither clipboard path is available — an embedded webview,
   * a restrictive permissions policy, an unfocused document — select the code
   * so the shopper can copy it with a long-press. A chip that does nothing
   * when tapped is the one outcome worth engineering around.
   */
  function selectCode(button) {
    /* The campaign band and the coupon popup both use this handler. The
       popup marks its value with a data attribute so new surfaces don't
       have to borrow the campaign's class name to get copy-to-clipboard. */
    var value = button.querySelector('[data-toads-copy-value], .toads-campaign__code-value');
    if (!value) return;
    try {
      var range = document.createRange();
      range.selectNodeContents(value);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      button.setAttribute('data-copy-manual', 'true');
      setTimeout(function () { button.removeAttribute('data-copy-manual'); }, 4000);
    } catch (e) {}
  }

  function legacyCopy(code) {
    var scratch = document.createElement('textarea');
    scratch.value = code;
    scratch.setAttribute('readonly', '');
    scratch.style.position = 'fixed';
    scratch.style.top = '-1000px';
    document.body.appendChild(scratch);
    scratch.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(scratch);
    return ok;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-toads-copy]');
    if (!button) return;

    var code = button.getAttribute('data-toads-copy');
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(
        function () { flash(button); },
        function () {
          // Permission policy or an embedded webview can refuse the async
          // clipboard. Fall through rather than failing silently.
          if (legacyCopy(code)) { flash(button); } else { selectCode(button); }
        }
      );
      return;
    }

    if (legacyCopy(code)) { flash(button); } else { selectCode(button); }
  });

  /* A countdown is decoration. If it ever throws, it must not take the
   * click-to-copy handler — or anything else on the page — down with it. */
  function safeRun() {
    try { run(); } catch (e) { if (window.console) console.warn('[toads] countdown:', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeRun);
  } else {
    safeRun();
  }
  document.addEventListener('shopify:section:load', safeRun);
})();
